import { getValue, compareValue } from '../utils/formValue';
export default function initMustBeTrueIfValidator() {

    $.validator.addMethod("mustbetrueif",
        function (value, element, params) {
            var name1 = params["compareproperty"];
            var valueToCompare1 = getValue(name1);

            // compare targetvalue to compareproperty or value
            var comparisonIsOk1 = compareValue(
                valueToCompare1,
                params["operator"],
                params["comparepropertyvalue"],
                params["type"],
                params
            );
            var comparisonIsOk2 = true;
            var name2 = params["compareproperty2"];
            if (name2) {
                var valueToCompare2 = getValue(name2);
                comparisonIsOk2 = compareValue(
                    valueToCompare2,
                    params["operator2"],
                    params["comparepropertyvalue2"],
                    params["type2"],
                    params
                );
            }

            var conditionsValid = false;
            var logicalOperator = params["logicaloperator"];
            if (logicalOperator == "OR") {
                conditionsValid = comparisonIsOk1 || comparisonIsOk2;
            } else { // logicalOperator == "AND" 
                conditionsValid = comparisonIsOk1 && comparisonIsOk2;
            }

            // if the conditions are true, reuse the existing mustbetrue field validator functionality
            if (conditionsValid) {
                return $.validator.methods.mustbetrue.call(this, $(element).is(":checked").toString(), element);
            }
            return true;
        })

    $.validator.unobtrusive.adapters.add("mustbetrueif", ["compareproperty", "comparepropertyvalue", "operator", "type", "logicaloperator", "compareproperty2", "comparepropertyvalue2", "operator2", "type2", "dateformat", "decimalchar"],
        function (options) {
            options.rules['mustbetrueif'] =
            {
                compareproperty: options.params.compareproperty,
                operator: options.params.operator,
                comparepropertyvalue: options.params.comparepropertyvalue,
                type: options.params.type,

                logicaloperator: options.params.logicaloperator,

                compareproperty2: options.params.compareproperty2,
                operator2: options.params.operator2,
                comparepropertyvalue2: options.params.comparepropertyvalue2,
                type2: options.params.type2,

                dateformat: options.params.dateformat,
                decimalchar: options.params.decimalchar
            };
            options.messages['mustbetrueif'] = options.message;
        }
    );
}
